//assets
import AnalyticsSvg from 'assets/icons/graphsAndData/analyticsSvg.svg';
import DashboardSvg from 'assets/icons/graphsAndData/dashboardSvg.svg';
import PeopleSvg from 'assets/icons/human/peopleSvg.svg';
import ChainSvg from 'assets/icons/itemsAndObjects/chainSvg.svg';
import CompassSvg from 'assets/icons/itemsAndObjects/compassSvg.svg';
import ListSvg from 'assets/icons/office/listSvg.svg';
import CalendarSvg from 'assets/icons/time/calendarSvg.svg';
//helpers
import getAllowedRoutes from 'helper/routes/getAllowedRoutes';

export const getToursMainNavigation = () => {
  return getAllowedRoutes(null, [
    {
      label: 'Dashboard',
      path: '/tours/dashboard',
      icon: DashboardSvg,
    },
    {
      label: 'Calendar',
      path: '/tours/calendar',
      icon: CalendarSvg,
    },
    {
      label: 'Reservations',
      path: '/tours/reservations',
      icon: ListSvg,
    },
    {
      label: 'Guests',
      path: '/tours/guests',
      icon: PeopleSvg,
    },
    {
      label: 'Tours',
      path: '/tours/all',
      icon: CompassSvg,
    },
    {
      label: 'Integrations',
      path: '/tours/channel-manager',
      icon: ChainSvg,
    },
    {
      label: 'Analytics',
      path: '/tours/analytics',
      icon: AnalyticsSvg,
    },
  ]);
};
